// SPDX-FileCopyrightText: Copyright 2024 Dash0 Inc.
import React from "react";

import SearchedTextHighlighterWithoutAutoExpansion from "@/components/shared/search/search-text-highlighter-without-auto-expansion";
import { BetaTag } from "@/components/ui/beta-tag";
import { ExtendedIntegrationMetadata } from "@/hub/types";
import { IntegrationDocSection } from "./integration-doc-section";
import Link from "next/link";

type IntegrationDetailPageHeaderProps = {
  integration: ExtendedIntegrationMetadata;
};

export function IntegrationDetailPageHeader({
  integration,
}: IntegrationDetailPageHeaderProps) {
  return (
    <section>
      <div className="flex relative lg:gap-[30px]">
        <div className="lg:min-w-[306px]" />
        <div className="flex gap-1">
          <Link
            href="/hub/integrations"
            className="text-grey text-sm font-medium"
          >
            Hub
          </Link>
          <span className="text-gray-[#757575]">/</span>
          <span className="text-white font-medium text-sm">
            {integration.label}
          </span>
        </div>
      </div>

      <IntegrationDocSection
        className="mt-10!"
        withBorder={false}
        doc={{
          id: "integration-header",
          label: "Technology",
        }}
      >
        <div className="mb-8 flex items-center gap-2">
          <h1 className="text-[30px] m-0">{integration.label}</h1>
          {integration.beta && <BetaTag />}
        </div>
        {integration.description && (
          <p className="text-gray-500 text-[17px] font-medium leading-[23.8px]">
            {integration.description}
          </p>
        )}
      </IntegrationDocSection>
    </section>
  );
}
